import { isFunction } from "lodash";
const useImageSocialAttributes = ({
  src,
  config,
  width,
  height
}) => {
  if (src === void 0 || config?.imageProps === void 0) {
    return {};
  }
  const imageProps = isFunction(config.imageProps) ? config.imageProps({ url: src.url, file_name: src.id, width, height }) : config.imageProps;
  return ["data-pin-nopin", "data-pin-url", "data-pin-media"].reduce(
    (socialAttributes, attribute) => {
      if (imageProps[attribute]) {
        return { ...socialAttributes, [attribute]: imageProps[attribute] };
      }
      return socialAttributes;
    },
    {}
  );
};
export {
  useImageSocialAttributes
};
//# sourceMappingURL=use-image-social-attributes.js.map
